class ToggleGroupComponent extends HTMLElement {
  constructor() {
    super();
    this._syncFrame = null;
    this._scheduleSync = this._scheduleSync.bind(this);
  }
  connectedCallback() {
    this._resizeObserver = new ResizeObserver(this._scheduleSync);
    this._resizeObserver.observe(this);
    this._mutationObserver = new MutationObserver(this._scheduleSync);
    this._mutationObserver.observe(this, {
      attributes: true,
      attributeFilter: ["class"],
      childList: true,
      subtree: true
    });
    this._scheduleSync();
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this._resizeObserver) == null ? void 0 : _a.disconnect();
    (_b = this._mutationObserver) == null ? void 0 : _b.disconnect();
    if (this._syncFrame) cancelAnimationFrame(this._syncFrame);
    this._syncFrame = null;
  }
  _scheduleSync() {
    if (this._syncFrame) return;
    this._syncFrame = requestAnimationFrame(() => {
      this._syncFrame = null;
      if (this.isConnected) this.sync();
    });
  }
  sync() {
    const indicator = this.querySelector("[data-toggle-group-indicator]");
    const activeItem = this.querySelector("[data-toggle-group-item].active");
    if (!indicator) return;
    if (!activeItem) {
      this.dataset.toggleGroupReady = "true";
      return;
    }
    if (activeItem.offsetWidth === 0) return;
    this.style.setProperty(
      "--toggle-group-indicator-offset",
      `${activeItem.offsetLeft}px`
    );
    this.style.setProperty(
      "--toggle-group-indicator-width",
      `${activeItem.offsetWidth}px`
    );
    this.style.setProperty(
      "--toggle-group-indicator-offset-y",
      `${activeItem.offsetTop}px`
    );
    this.style.setProperty(
      "--toggle-group-indicator-height",
      `${activeItem.offsetHeight}px`
    );
    this.dataset.toggleGroupReady = "true";
  }
}
if (!customElements.get("toggle-group-component")) {
  customElements.define("toggle-group-component", ToggleGroupComponent);
}
